import React from 'react'
import { useTranslation } from 'react-i18next'
import './404.css'

type Props = {}

const P404: React.FC<Props> = () => {
  const { t } = useTranslation()

  return (
    <div id="unexpected-error" style={{ flexDirection: 'column' }}>
      <section className="unexpected-error-block">
        <div className="row no-gutters align-items-center">
          <div className="col-12 unexpected-error-content p-4">
            <h1>404</h1>
            {t('messages.pageNotFoundMsg')}
          </div>
        </div>
      </section>
      <div aria-hidden="true" className="plaintext-button">
        <span aria-hidden="true" onClick={() => { window.history.back() }}>
          {t('actions.goBack')}
        </span>
      </div>
    </div>
  )
}

export default P404
